export default {
  getInvoicePdfList: (state) => state.invoicePdfList,
  getReceiptPdfList: (state) => state.receiptPdfList,
};
